import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AngularFireModule } from '@angular/fire';
import { FirebaseUIModule, firebase, firebaseui } from 'firebaseui-angular';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDialogModule, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NouisliderModule } from 'ng2-nouislider';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ConfirmComponent } from './confirm/confirm.component';
import { CdkDetailRowDirective } from './directives/cdk-detail-row.directive';
import { DisclaimerComponent } from './disclaimer/disclaimer.component';
import { ChartComponent } from './filings/chart/chart.component';
import { CikComponent } from './filings/cik/cik.component';
import { DetailsComponent } from './filings/details/details.component';
import { FilingsComponent } from './filings/filings.component';
import { NewsComponent } from './filings/news/news.component';
import { QuoteComponent } from './filings/quote/quote.component';
import { SliderTotalValueComponent } from './filings/sub-header/slider/slider-total-value.component';
import { SliderPriceComponent } from './filings/sub-header/slider/sliderPrice.component';
import { SubHeaderComponent } from './filings/sub-header/sub-header.component';
import { HeaderComponent } from './header/header.component';
import { PaymentComponent } from './payment/payment.component';
import { CommaPipe } from './pipes/comma.pipe';
import { RolePipe } from './pipes/role.pipe';
import { RolesPipe } from './pipes/roles.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { PrivacyComponent } from './privacy/privacy.component';
import { SuccessComponent } from './success/success.component';
import { AuthComponent } from './auth/auth.component';

@NgModule({
  declarations: [
    AppComponent,
    PaymentComponent,
    PrivacyComponent,
    ConfirmComponent,
    HeaderComponent,
    DisclaimerComponent,
    SuccessComponent,
    FilingsComponent,
    RolePipe,
    RolesPipe,
    CommaPipe,
    SafeHtmlPipe,
    CdkDetailRowDirective,
    NewsComponent,
    CikComponent,
    ChartComponent,
    QuoteComponent,
    DetailsComponent,
    SubHeaderComponent,
    SliderPriceComponent,
    SliderTotalValueComponent,
    AuthComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MatToolbarModule,
    MatCardModule,
    MatSelectModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatSliderModule,
    MatTableModule,
    MatPaginatorModule,
    MatDialogModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    FirebaseUIModule.forRoot(environment.firebaseUiAuthConfig),
    BrowserAnimationsModule,
    NouisliderModule
  ],
  entryComponents: [
    AuthComponent
  ],
  providers: [CommaPipe,
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: true } }],
  bootstrap: [AppComponent]
})
export class AppModule { }
